// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCtG7wOH5aARFnnWBj1MZG3th3DrdryIoM",
    authDomain: "aladdinclean-516c4.firebaseapp.com",
    projectId: "aladdinclean-516c4",
    storageBucket: "aladdinclean-516c4.appspot.com",
    messagingSenderId: "431517804056",
    appId: "1:431517804056:web:a26b202bf99c04f9ae056d",
    measurementId: "G-18XLVXPJY3"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
